import { Link, Navigate, useLocation } from 'react-router-dom';
import styles from './SignupComplete.module.scss';

interface SignupCompleteState {
  name?: string;
}

function SignupComplete() {
  const location = useLocation();
  const state = (location.state as SignupCompleteState | null) ?? null;

  // 가입 직후에만 진입할 수 있다. 직접 들어오거나 새로고침으로 state가 없으면 홈으로 보낸다
  if (!state?.name) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <svg viewBox="0 0 24 24">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>
        <span className={styles.eyebrow}>Welcome</span>
        <h1 className={styles.title}>회원가입을 축하합니다!</h1>
        <p className={styles.desc}>
          <strong>{state.name}</strong>님, G-WORKS의 회원이 되신 것을 환영합니다.
          <br />
          이제 견적 문의와 주문 내역을 마이페이지에서 편하게 확인하실 수 있습니다.
        </p>
        <div className={styles.actions}>
          <Link to="/quote" className={styles.btn}>
            견적 문의하기
          </Link>
          <Link to="/mypage" className={`${styles.btn} ${styles.primary}`}>
            마이페이지
          </Link>
        </div>
        <div className={styles.homeLink}>
          <Link to="/">홈으로 가기</Link>
        </div>
      </div>
    </div>
  );
}

export default SignupComplete;
